module.exports = ".switch:hover, .switch:hover * {\r\n    color: hsl(217, 71%, 53%);\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/me/components/update-password-card/update-password-card.component.css
// module id = ./src/app/me/components/update-password-card/update-password-card.component.css
// module chunks = main